const itTranslation = {
  common: {
    close: 'Chiudi',
    welcome: 'Benvenuto',
    login: 'Accedi',
    logout: 'Esci',
    send: 'Invia',
    stop: 'Ferma',
    retry: 'Riprova',
    loading: 'Caricamento...',
    error: 'Errore',
    success: 'Successo',
    cancel: 'Annulla',
    confirm: 'Conferma',
    typeToFilter: 'Digita per filtrare…',
    save: 'Salva',
    language: 'Lingua',
    newChat: 'Nuova conversazione',
    startingNewChat: 'Avvio di una nuova conversazione...',
    searchMessage: 'Elaborazione e analisi delle informazioni rilevanti...',
    searchMessageTiming: 'Ricerca tra istruzioni di lavoro e elementi di conoscenza...',
    tryAgain: 'Riprova',
    back: 'Indietro',
    enabled: 'Attivato',
    disabled: 'Disattivato',
    goBack: 'Torna indietro',
    attachDocument: 'Allega documento',
    aiDisclaimer:
      "Le risposte sono generate dall'IA. Verifica sempre le informazioni importanti tramite fonti ufficiali.",
    copyAnswer: 'Copia risposta',
    copyMessage: 'Copia messaggio',
    copied: 'Copiato!',
    copyToClipboard: 'Copia negli appunti',
    expand: 'Espandi',
    minimize: 'Riduci',
    showMore: 'Mostra di più',
    noInternalKnowledge: 'Nessuna conoscenza interna trovata',
    noAdditionalResponse: 'Nessuna risposta aggiuntiva',
    swapMessage:
      "Abbiamo trovato una risposta specifica per l'azienda. La risposta generale è ancora disponibile di seguito.",
    toggleShowGeneral: 'Mostra risposta generale (ChatGPT)',
    toggleHideGeneral: 'Nascondi risposta generale',
    progressExternal: 'Ricerca con ChatGPT…',
    progressInternal: 'Ricerca nella conoscenza aziendale…',
    internalError: 'Conoscenza aziendale al momento non disponibile.',
    promoteSecondary: 'Usa come risposta principale',
    compareAnswers: 'Confronta le risposte affiancate',
    switchBack: 'Torna indietro',
    generalInformation: 'ChatGPT',
    internalGuidelines: 'Linee guida interne',
  },
  // Retrieval-step labels, keyed by graph tool prefix. A per-source key
  // (`tools.graph_search_<key>.done`) overrides these when one is defined.
  tools: {
    graph_search: {
      active: 'Ricerca nel knowledge graph…',
      done: 'Knowledge graph consultato',
    },
    ask_clarification: {
      active: 'Preparazione di una domanda di chiarimento…',
      done: 'Domanda di chiarimento posta',
    },
    unknown: {
      active: '{{name}} in corso…',
      done: '{{name}} completato',
    },
    statusDone: 'Completato',
    statusRunning: 'In corso…',
  },
  clarification: {
    escapeHatchLabel: 'Scrivi la mia risposta',
    skip: 'Salta',
    submit: 'Invia',
    nextQuestion: 'Domanda successiva',
    previousQuestion: 'Domanda precedente',
    selectAllThatApply: '(Seleziona tutte le opzioni pertinenti)',
    stepCounter: '{{current}} di {{total}}',
    selectedCount: '{{count}} selezionati',
    selectOption: 'Seleziona {{label}}',
    deselectOption: 'Deseleziona {{label}}',
    shortcutHint: '↑↓ per navigare · Invio per selezionare · Maiusc+Invio per inviare · Esc per saltare',
  },
  knowledge_source: {
    badge_ai: 'IA',
    badge_internal: 'Dati aziendali',
    badge_internet: 'Internet',
  },
  errors: {
    assistantResponseContentViolation:
      "La risposta dell'assistente viola la nostra policy sui contenuti. Riprova o riformula la domanda.",
    userInputContentViolation:
      'La tua richiesta contiene contenuti che violano la nostra policy. Per favore, riformula la domanda.',
    llmProviderUserInputBlocked:
      'Il tuo messaggio è stato bloccato dal filtro dei contenuti del provider IA. Riformula la domanda.',
    llmProviderBotResponseBlocked:
      "La risposta dell'IA è stata bloccata dal filtro del provider. Riprova o riformula la domanda.",
    llmProviderApiError: 'Stiamo riscontrando problemi con il nostro servizio IA. Riprova più tardi.',
    modelRateLimited:
      'Il modello IA è occupato in questo momento. Riprova — se resta occupato, risponderà un altro modello.',
    modelTimeout: 'Il modello IA ha impiegato troppo tempo per rispondere. Riprova.',
    modelUnavailable:
      'Il modello IA non è disponibile in questo momento. Riprova — risponderà un altro modello.',
    serverError:
      'Si è verificato un errore imprevisto del server. Riprova o contatta il supporto se il problema persiste.',
    agentNotFound: "L'assistente che stai cercando non esiste o non è più disponibile.",
    conversationNotFound: 'La conversazione che stai cercando non esiste o non è più disponibile.',
    noAccessScopes:
      'Al momento non hai accesso a nessuna fonte di conoscenza. Per richiedere l’accesso, crea un ticket di supporto o contatta il tuo amministratore IT.',
    noAccessScopesWithEmail:
      'Al momento non hai accesso a nessuna fonte di conoscenza. Per richiedere l’accesso, crea un ticket di supporto o contatta il supporto IT all’indirizzo {{email}}.',
    startViolatedPoliciesList: 'Sono state violate le seguenti policy',
    questionTooLong: {
      title: 'La tua domanda è troppo lunga',
      description: 'La lunghezza massima è di 30.000 caratteri.',
    },
    excelNotSupportedYet: {
      title: 'Supporto Excel e CSV in arrivo!',
      description:
        'Stiamo lavorando al supporto per file Excel e CSV che sarà presto disponibile. Per ora usa file PDF o Word.',
    },
    internetSearchNotWaiting: "Questa ricerca ha già ricevuto una risposta, ad esempio in un'altra scheda. Aggiorna la pagina per vedere il risultato.",
  },
  auth: {
    welcomeTester: 'Benvenuto collega',
    welcomeMessage: 'Benvenuto in {{assistantName}}!',
    loginWithMicrosoft: 'Accedi con Microsoft',
    loginInstructions: 'Accedi con il tuo account Microsoft per iniziare.',
    welcomeCompany: 'Benvenuto in {{companyName}}!',
    loginWithPassword: 'Accedi con nome utente e password',
    hidePasswordForm: 'Nascondi',
    login: 'Accedi',
  },
  chat: {
    placeholder: 'Fai la tua domanda qui',
    thinking: 'Sto pensando...',
    anonymousUser: 'Anonimo',
    howToAskGoodQuestion: 'Come fare una buona domanda?',
    askQuestion: 'Fai la tua domanda',
    exampleQuestions: 'Domande di esempio',
    tryAsking: 'Prova a chiedere:',
    assistant: '{{assistantName}}, il tuo assistente digitale',
    welcomeMessage:
      'Ciao {{name}}! Sono {{assistantName}}, il tuo assistente digitale. Posso aiutarti con domande sulle istruzioni di lavoro e sugli elementi di conoscenza. Cosa vuoi sapere?',
    loading: 'Caricamento della conversazione...',
    timingKnowledge: 'TIPP',
    chatgpt: 'ChatGPT',
    internet: 'Internet',
    serverError:
      'Si è verificato un errore imprevisto del server. Riprova o contatta il supporto se il problema persiste.',
    disclaimerText:
      "Risposte generate dall'IA. Da queste risposte non può derivare alcun diritto.",
    dropFilesHere: 'Trascina qui i file per aggiungerli alla chat',
    addMenu: 'Aggiungi',
    addFiles: 'Aggiungi file',
    knowledgeSourceOff: '{{name}} disattivato',
    filteredTo: 'Filtrato per',
    talkingTo: 'Stai parlando con {{name}}',
    leaveAgent: 'Lascia {{name}}',
    askAgain: 'Chiedi a un altro assistente',
    askAgent: 'Chiedi a {{name}}',
    filters: 'Filtri',
    filtersInfo: 'Limita la chat a filtri specifici.',
    unsupportedFileType: 'Tipo di file non supportato',
    uploadingFile: 'Caricamento del file…',
    uploadLimit: 'Fino a {{max}} file, massimo 10 MB ciascuno',
    fileTooLarge: 'Il file deve essere inferiore a 10 MB',
    fileTypeNotAllowed: 'Sono consentiti solo file PDF, Word, Excel, PowerPoint (PPTX), CSV e TXT',
    fileTypeNotAllowedWithImages:
      'Sono consentiti solo file PDF, Word, Excel, PowerPoint (PPTX), CSV, TXT e immagini (PNG, JPEG, WEBP)',
    documentUploadFailed: 'Caricamento del documento non riuscito',
    tooManyFiles: 'Puoi allegare fino a {{max}} file per messaggio',
    attachmentsNotReady: 'Attendi il caricamento di tutti i file o rimuovi quelli non riusciti',
    retryAttachment: 'Riprova a caricare {{name}}',
    removeAttachment: 'Rimuovi {{name}}',
  },
  answerStatus: {
    checking: 'Controllo delle query…',
    internet: 'Ricerca su Internet: {{query}}',
    knowledge: 'Ricerca nei dati aziendali: {{query}}',
    document: 'Lettura del tuo documento…',
    files_one: 'Elaborazione del file: {{name}}',
    files_other: 'Elaborazione di {{count}} file…',
    image: 'Analisi dell\'immagine…',
    imageNamed: 'Analisi dell\'immagine: {{name}}',
    slowFiles: 'I file grandi con molte immagini possono richiedere alcuni minuti…',
  },
  internetSearch: {
    badgeLabel: 'Ricerca su Internet',
    queriesSent_one: '{{count}} query inviata',
    queriesSent_other: '{{count}} query inviate',
    badgeTooltip: 'Questo assistente può cercare su Internet',
    approval: {
      queryTooLong: 'Riduci la query a un massimo di 500 caratteri.',
      title: 'Consentire la ricerca su Internet?',
      descriptionOne: 'Questa query va su Internet e potrebbe contenere dati riservati (evidenziati). Modificala o inviala così com’è.',
      descriptionMany: 'Queste query vanno su Internet e potrebbero contenere dati riservati (evidenziati). Modificale o inviale così come sono.',
      descriptionUncheckedOne: 'Questa query va su Internet. Non siamo riusciti a controllarla automaticamente: verificala tu prima di inviarla.',
      descriptionUncheckedMany: 'Queste query vanno su Internet. Non siamo riusciti a controllarle automaticamente: verificale tu prima di inviarle.',
      descriptionCleanOne: 'Questa query va su Internet. Controllala: modificala o inviala così com\'è.',
      descriptionCleanMany: 'Queste query vanno su Internet. Controllale: modificale o inviale così come sono.',
      queryLabel: 'Query di ricerca',
      dropQuery: 'Non cercare',
      dropped: 'Non verrà cercata',
      undrop: 'Cerca comunque',
      sendSearch: 'Avvia ricerca',
      useInternal: 'Usa i dati interni',
      continueWithoutInternet: 'Continua senza Internet',
      internalStatus: 'Ricerca su Internet ignorata · Utilizzo dei dati interni',
      noInternetStatus: 'Ricerca su Internet ignorata · Risposta senza Internet',
      categories: {
        customer: 'nome cliente',
        person: 'persona',
        vessel: 'nave',
        project: 'progetto',
        internal_code: 'codice interno',
        contact: 'recapiti',
        financial: 'finanziario',
        credential: 'credenziali di accesso',
        identifier: 'numero identificativo',
        special_category: 'dati personali sensibili',
        confidential: 'riservato',
        other: 'possibilmente riservato',
      },
    },
  },
  agentChat: {
    placeholder: "Inserisci la tua domanda per l'assistente...",
    welcomeMessage: 'Ciao, sono il tuo agente IA. Come posso aiutarti oggi?',
    privilegedWelcomeMessage: 'Ciao {{userName}}! {{description}}',
    startPrompt: 'Fai una domanda per iniziare',
  },
  profile: {
    settings: 'Impostazioni',
    selectLanguage: 'Seleziona la tua lingua',
    appearance: 'Aspetto',
    darkMode: 'Modalità scura',
    languageChanged: 'Lingua cambiata',
    noEmailAvailable: 'Nessuna e-mail disponibile',
    general: 'Generale',
    models: 'Modelli',
    noModelsAvailable: 'Nessun modello disponibile',
    modelSettings: 'Impostazioni modello',
    savingSettings: 'Salvataggio...',
    settingsUpdateFailed: 'Impossibile salvare le impostazioni del modello. Riprova.',
  },
  sidebar: {
    conversations: 'Cronologia',
    assistants: 'Assistenti',
    userGuide: 'Guida utente',
    chatHistory: 'Cronologia delle conversazioni',
    today: 'Oggi',
    thisWeek: 'Questa settimana',
    lastWeek: 'La settimana scorsa',
    earlier: 'In precedenza',
    conversation: 'Conversazione',
    noAssistantsAvailable: 'Nessun assistente disponibile',
    noContent: 'Nessun contenuto',
    noPreviousConversations: 'Nessuna cronologia precedente trovata',
    searchConversations: 'Cerca nella cronologia...',
    noSearchResults: 'Nessuna cronologia corrispondente alla tua ricerca',
    favorites: 'Preferiti',
    noFavorites: 'Nessun preferito',
    addFavoritesHint: 'Vai alla libreria per aggiungere assistenti ai preferiti.',
    loadingPrivilegedAgents: 'Caricamento assistenti...',
    rename: 'Rinomina',
    conversationActions: 'Azioni conversazione',
    renameConversationError: 'Impossibile rinominare la conversazione',
    delete: 'Elimina',
    deleteConversation: 'Elimina conversazione',
    deleteConversationConfirm: 'Sei sicuro di voler eliminare la conversazione: {{title}}?',
    deleteConversationError: 'Impossibile eliminare la conversazione',
  },
  feedback: {
    likeAnswer: 'Mi piace la risposta',
    dislikeAnswer: 'Non mi piace la risposta',
    feedbackSent: 'Il tuo feedback è stato inviato! ✅',
    provideFeedback: 'Fornisci un feedback sulla domanda',
    enterFeedback: 'Inserisci qui il tuo feedback',
    send: 'Invia',
    assistantFallback: "assistente IA",
    downvoteDisclaimer:
      "Quando premi Invia, i tuoi ultimi due messaggi verranno condivisi in forma anonima per l'analisi, così da contribuire a migliorare {{assistant}}.",
    reasons: {
      incorrect: 'La risposta è errata',
      sourceIncorrect: 'La fonte è errata',
      other: 'Altro...',
    },
  },
  // Generic information pop-out — client-agnostic.
  // Texts are feature-flag driven and use {{companyName}} for the company name.
  informationModal: {
    title: "Informazioni sull'assistente {{companyName}}",
    intro:
      "Benvenuto nell'assistente {{companyName}}. Qui sotto trovi con cosa l'assistente può aiutarti e come ottenerne il massimo.",
    capabilitiesTitle: "Con cosa può aiutarti l'assistente?",
    activeVanillaChat:
      "L'assistente può rispondere a domande come quelle che faresti a ChatGPT.",
    activeVanillaInactiveWebSearch:
      "L'assistente ha ampie conoscenze generali, ma non conosce eventi attuali come le ultime notizie.",
    activeInternalSearch:
      "L'assistente può rispondere a domande basandosi su una selezione specifica di fonti informative interne.",
    activeInternetSearch:
      "L'assistente può cercare su internet per rispondere a domande sull'attualità.",
    activeInternetSearchPrivacyWarning:
      "Nota: domande e risposte delle ricerche su internet, come per il normale uso di internet, non sono completamente private. Non condividere informazioni aziendali riservate quando usi la ricerca web.",
    activeDocumentUpload:
      "Puoi caricare documenti e parlarne con l'assistente, ad esempio per riassumerli o estrarre punti d'azione.",
    activeAgents:
      "Puoi selezionare <1>assistenti</1> specifici con cui parlare. Ogni assistente ha le proprie istruzioni e quindi è più adatto a compiti specifici.",
    activeModelSelection:
      "Nel campo di immissione scegli quale modello di IA risponde alla tua domanda. Nella <1>pagina delle impostazioni dei modelli</1> puoi modificare le impostazioni di ciascun modello per controllare come risponde.",
    usageTipsTitle: "Come ottenere il massimo dall'assistente",
    askClearQuestions:
      'Fai una domanda chiara con frasi complete. Le singole parole chiave spesso producono risposte mediocri; una frase completa fornisce all\'assistente il contesto necessario per aiutarti bene.',
    conversationHistory:
      "All'interno di una conversazione, l'assistente ricorda ciò che hai detto in precedenza, così puoi porre domande di follow-up. Tuttavia non capisce cosa intendi se ti riferisci a informazioni provenienti da altre conversazioni.",
    startNewConversation:
      "Inizia una nuova conversazione (pulsante in alto a sinistra) quando passi a un altro argomento, così le risposte restano pertinenti.",
    bewareAssistantsNotAgents:
      "Nota: questo è un assistente IA, non un agente IA. Ti aiuta con singoli compiti quando lo chiedi, ad esempio riassumere un'email, ma non esegue azioni di follow-up in modo autonomo, come inviare email.",
    feedback:
      "Usa i pollici sotto una risposta per dare feedback. In questo modo aiuti a migliorare l'assistente.",
    dataVisibilityNoticeTitle: 'Avviso sulla visibilità dei dati',
    bewareDoNotSharePersonalInformation: 'Nota: non condividere informazioni personali.',
    supportTitle: 'Hai bisogno di aiuto?',
  },
  conversations: {
    noAssistantsMessage: 'Sembra che non sia stata configurata alcuna biblioteca. Contatta il supporto.',
    searchPlaceholder: 'Cerca conversazioni',
    newChat: 'Nuovo chat',
    untitledConversation: 'Conversazione senza titolo',
    emptyStateTitle: 'Nessuna conversazione',
    emptyStateDescription: 'Non hai ancora conversazioni.',
    delete: 'Elimina',
    share: 'Condividi',
    rename: 'Rinomina',
    copyLink: 'Copia link',
    copiedLink: 'Link della conversazione copiato!',
    deleteWarning: 'Sei sicuro? Questa chat verrà eliminata definitivamente.',
    deleteFailed: 'Eliminazione della chat non riuscita',
    deleteSuccess: 'Chat eliminata',
  },
  homePage: {
    title: 'Chatta con {{assistantName}}',
    subtitle: '{{assistantName}} è un chatbot specializzato nella conoscenza della tua azienda.',
    newChat: 'Nuova conversazione',
    search: 'Cerca',
    feedback: 'Feedback',
    seeExamples: 'Vedi esempi',
    featuredTopics: 'Argomenti in evidenza',
    startWithTopic: 'Inizia con un argomento',
    appFeatures: "Funzionalità dell'app",
    libraryInformation: 'Informazioni sulla biblioteca',
  },
  search: {
    noResults: 'Nessun risultato trovato',
    tryDifferentQuery: 'Prova una query diversa o cerca un altro termine',
  },
  share: {
    inviteColleagues: 'Invita i colleghi a provare {{assistantName}}',
    and: 'e',
    shareConversations: 'Condividi le tue conversazioni con gli altri',
    sharePublic: 'Condividi con un link',
    shareTeams: 'Condividi in Teams',
    shareCopy: 'Copia',
    shared: 'Condiviso',
  },
  profilePage: {
    personalInformation: 'Informazioni personali',
    fullName: 'Nome completo',
    email: 'E-mail',
    accountId: 'ID account',
    role: 'Ruolo',
    language: 'Lingua',
    memberSince: 'Membro da',
  },
  assistantLibrary: {
    title: 'Libreria degli assistenti',
    subtitle: 'Scegli un assistente per iniziare',
    searchPlaceholder: 'Cerca assistenti...',
    category: 'Categoria',
    allCategories: 'Tutte le categorie',
    sortBy: 'Ordina per',
    createdAt: 'Creato il',
    updatedAt: 'Aggiornato il',
    name: 'Nome',
    description: 'Descrizione',
    mostPopular: 'Più popolari',
    myFavorites: 'I miei preferiti',
    results: 'Risultati',
    result: 'Risultato',
    noResultsFound: 'Nessun assistente trovato',
    assistantCard: {
      created: 'Creato',
      updated: 'Aggiornato',
      cta: 'Avvia chat',
    },
    filters: {
      reset: 'Reimposta',
      showFilters: 'Mostra filtri',
      hideFilters: 'Nascondi filtri',
    },
  },
  libraryBanner: {
    title: 'Benvenuto nella libreria degli assistenti',
    description:
      'Qui troverai assistenti specializzati per diverse esigenze, inclusi conformità HR, supporto tecnico, formazione utenti, analisi dei dati e altro.',
    readyToChat: 'Pronto a chattare?',
    browseAssistants: 'Sfoglia assistenti',
  },
  assistant: {
    welcomeTitle: 'Benvenuto su {{name}}',
    welcomeMessage: 'Inserisci la tua domanda o seleziona una delle domande di esempio qui sotto per iniziare.',
    conversations: 'Conversazioni',
    settings: 'Impostazioni',
    description: 'Descrizione',
    noDescription: 'Nessuna descrizione disponibile',
    exampleQuestions: 'Domande di esempio',
    createdAt: 'Creato il',
    updatedAt: 'Aggiornato il',
    createdBy: 'Creato da',
    timezone: 'Fuso orario',
    language: 'Lingua',
    public: 'Pubblico',
    private: 'Privato',
    knowledgeSource: 'Fonte di conoscenza',
    noKnowledgeSource: 'Nessuna fonte di conoscenza fornita',
    chat: 'Chat',
    prompts: 'Prompt',
    files: 'File',
    instructions: 'Istruzioni',
    loading: "Caricamento dell'assistente...",
    loadFailed: "Impossibile caricare l'assistente",
    retry: 'Riprova',
    startChat: 'Avvia chat',
    startNewChat: 'Inizia una nuova chat',
    inputPlaceholder: 'Inserisci il tuo messaggio...',
    uploadFile: 'Carica file',
    fileUploaded: 'File caricato',
    fileRemoved: 'File rimosso',
    fileUploadError: 'Errore durante il caricamento del file',
    fileRemoveError: 'Errore durante la rimozione del file',
    fileTooLarge: 'File troppo grande',
    fileTooLargeDescription: 'Dimensione massima del file 10 MB',
    fileTypeNotAllowed: 'Tipo di file non consentito',
    fileTypeNotAllowedDescription: 'Tipi di file consentiti: PDF, DOCX, TXT',
    send: 'Invia',
    sending: 'Invio...',
    messageSent: 'Messaggio inviato',
    messageFailed: 'Invio del messaggio non riuscito',
    newMessage: 'Nuovo messaggio',
    clearChat: 'Cancella chat',
    confirmClearChat: 'Sei sicuro di voler cancellare la chat? Questa azione non può essere annullata.',
    chatCleared: 'Chat cancellata',
    chatClearFailed: 'Cancellazione della chat non riuscita',
    copyConversation: 'Copia conversazione',
    conversationCopied: 'Conversazione copiata',
    copyFailed: 'Copia non riuscita',
    feedback: 'Feedback',
    submitFeedback: 'Invia feedback',
    feedbackSent: 'Feedback inviato',
    feedbackFailed: 'Invio del feedback non riuscito',
    feedbackPlaceholder: "Com'è stata la tua esperienza?",
    ratingRequired: 'Seleziona una valutazione',
    optional: 'Opzionale',
    required: 'Obbligatorio',
  },
  assistantSettings: {
    title: 'Impostazioni assistente',
    description: 'Regola la configurazione del tuo assistente',
    tabs: {
      general: 'Generale',
      permissions: 'Permessi',
      knowledge: 'Conoscenza',
      behavior: 'Comportamento',
    },
    save: 'Salva impostazioni',
    saved: 'Impostazioni salvate',
    saveError: 'Errore durante il salvataggio delle impostazioni',
  },
  assistantGeneral: {
    title: 'Impostazioni generali',
    name: 'Nome',
    description: 'Descrizione',
    timezone: 'Fuso orario',
    language: 'Lingua',
    visibility: 'Visibilità',
    public: 'Pubblico',
    private: 'Privato',
    save: 'Salva',
    saved: 'Salvato',
    saveError: 'Errore durante il salvataggio',
  },
  assistantPermissions: {
    title: 'Permessi',
    addUser: 'Aggiungi utente',
    addGroup: 'Aggiungi gruppo',
    searchUsers: 'Cerca utenti',
    searchGroups: 'Cerca gruppi',
    invite: 'Invita',
    invited: 'Invitato',
    inviteError: "Errore durante l'invito",
    remove: 'Rimuovi',
    removed: 'Rimosso',
    removeError: 'Errore durante la rimozione',
    access: 'Accesso',
    accessLevels: {
      owner: 'Proprietario',
      editor: 'Editor',
      viewer: 'Visualizzatore',
    },
  },
  assistantKnowledge: {
    title: 'Fonte di conoscenza',
    addSource: 'Aggiungi fonte',
    searchSources: 'Cerca fonti',
    upload: 'Carica',
    uploaded: 'Caricato',
    uploadError: 'Errore di caricamento',
    remove: 'Rimuovi',
    removed: 'Rimosso',
    removeError: 'Errore durante la rimozione',
    sourceType: 'Tipo di fonte',
    sourceTypes: {
      document: 'Documento',
      url: 'URL',
      database: 'Database',
    },
  },
  assistantBehavior: {
    title: 'Comportamento',
    instructions: 'Istruzioni',
    addInstruction: 'Aggiungi istruzione',
    model: 'Modello',
    temperature: 'Temperatura',
    maxTokens: 'Token massimi',
    topP: 'Top P',
    frequencyPenalty: 'Penalità di frequenza',
    presencePenalty: 'Penalità di presenza',
    reset: 'Reimposta',
    resetConfirm: 'Vuoi davvero reimpostare questo comportamento ai valori predefiniti?',
    resetSuccess: 'Comportamento reimpostato',
    resetFailed: 'Reimpostazione non riuscita',
  },
  promptTemplates: {
    title: 'Modelli di prompt',
    subtitle: 'Crea e gestisci prompt riutilizzabili',
    create: 'Crea modello',
    edit: 'Modifica modello',
    delete: 'Elimina modello',
    name: 'Nome',
    description: 'Descrizione',
    content: 'Contenuto',
    created: 'Modello creato',
    updated: 'Modello aggiornato',
    deleted: 'Modello eliminato',
    creationError: 'Errore durante la creazione del modello',
    updateError: "Errore durante l'aggiornamento del modello",
    deletionError: "Errore durante l'eliminazione del modello",
    deleteConfirmTitle: 'Elimina modello',
    deleteConfirmMessage: 'Sei sicuro di voler eliminare questo modello?',
    deleteWarning: 'Questa azione non può essere annullata.',
  },
  promptForm: {
    name: 'Nome',
    namePlaceholder: 'Inserisci il nome del modello',
    nameHelp: 'Scegli un nome descrittivo per il modello',
    description: 'Descrizione',
    descriptionPlaceholder: 'Inserisci la descrizione del modello',
    descriptionHelp: 'Breve panoramica dello scopo del modello',
    content: 'Contenuto',
    contentPlaceholder: 'Inserisci il contenuto del prompt',
    contentHelp: 'Usa variabili come {{name}} e {{context}}',
    save: 'Salva modello',
    saving: 'Salvataggio...',
    saved: 'Modello salvato',
    saveError: 'Errore durante il salvataggio del modello',
  },
  agentBuilder: {
    back: 'Indietro',
    next: 'Avanti',
    saveAsDraft: 'Salva come bozza',
    saveAndFinish: 'Salva e termina',
    launchAssistant: 'Avvia assistente',
    previous: 'Precedente',
    continue: 'Continua',
    cancel: 'Annulla',
  },
  createAgent: {
    title: 'Crea assistente',
    subtitle: 'Configura il tuo nuovo assistente IA',
    name: 'Nome',
    description: 'Descrizione',
    language: 'Lingua',
    timezone: 'Fuso orario',
    visibility: 'Visibilità',
    public: 'Pubblico',
    private: 'Privato',
    next: 'Avanti',
    back: 'Indietro',
    create: 'Crea assistente',
    creating: 'Creazione...',
    created: 'Assistente creato',
    createError: "Errore durante la creazione dell'assistente",
    required: 'Questo campo è obbligatorio',
    tools: 'Strumenti',
    toolsFileSearch: 'Ricerca file',
    toolsImageInspection: 'Ispezione immagini',
    toolsKnowledgeSearch: 'Cerca in tutte le fonti di conoscenza',
    toolsGraphSearch: 'Cerca nel knowledge graph',
    toolsClarification: 'Fare domande di chiarimento',
    toolsKnowledgeSource: 'Cerca in {{name}}',
    toolsColumnName: 'Strumento',
    toolsColumnEnabled: 'Attivato',
    toolsColumnTraced: 'Tracciato',
    toolsTopK: 'Documenti per ricerca',
    toolsTopKHelp: 'Quanti documenti restituisce una ricerca nella base di conoscenza. Lascia vuoto per il valore predefinito (5). Un valore più alto copre di più, uno più basso mantiene la risposta focalizzata.',
    toolsTracedHelp: "Quando la modalità di tracciamento dell'assistente è 'Quando si usano gli strumenti', l'uso di questo strumento registra la conversazione in forma anonima a fini di analisi.",
    toolsInternetSearch: 'Ricerca Internet',
    flags: 'Segnalazioni',
    flagsHelp: 'Scegli quali segnalazioni può mostrare questo assistente. Per impostazione predefinita si applicano tutte — disattiva quelle non pertinenti al suo argomento.',
    flagsColumnName: 'Segnalazione',
    flagsColumnSeverity: 'Gravità',
    flagsColumnEnabled: 'Si applica',
    flagsSeverityInfo: 'Info',
    flagsSeverityWarning: 'Avviso',
    flagsSeverityCritical: 'Critico',
    tracing: 'Tracciamento',
    tracingHelp: 'Controlla se e come il comportamento interno di questo agente viene registrato a scopo diagnostico. Sostituisce le impostazioni basate sugli strumenti',
    tracingAlways: 'Attivo',
    tracingNever: 'Disattivato',
    tracingToolBased: 'Basato sugli strumenti',
    visibilityHelp: 'Controlla chi può vedere questo assistente. Gli assistenti privati sono visibili solo a te.',
    visibilityPublic: 'Rendi visibile alle entità cliente selezionate',
    visibilityEntities: 'Entità cliente',
    visibilityEntitiesPlaceholder: 'Seleziona entità cliente',
    visibilityEntitiesHelp: 'Gli utenti associati a una di queste entità possono vedere questo assistente.',
    routing: 'Chat principale',
    routingHelp: 'La chat principale passa a questo assistente le domande adatte. Il router legge la descrizione di instradamento e le domande di esempio.',
    routingDescription: 'Descrizione di instradamento',
    routingDescriptionPlaceholder: 'Da usare per: …\nNon per: …\nEsempi: …',
    routingDescriptionHelp: 'Indica a cosa serve questo assistente e, altrettanto importante, a cosa non serve, soprattutto dove confina con altri assistenti. Usa le parole che le persone scrivono davvero, nella loro lingua. {{count}}/{{max}} caratteri.',
    routingDescriptionTooLong: 'Al massimo {{max}} caratteri.',
    routingAvailable: 'Disponibile nella chat principale',
    routingNotReady: 'Richiede una descrizione di instradamento e almeno {{min}} domande di esempio.',
    routingUseClientContext: 'Usa il contesto aziendale',
    routingUseClientContextHelp: 'Inserisce il contesto aziendale (sedi, prodotti, cultura) prima delle istruzioni specifiche di questo assistente. Le sue istruzioni hanno la precedenza.',
    unsavedChanges: 'Modifiche non salvate',
    unsavedChangesMessage: 'Hai apportato modifiche che non sono ancora state salvate. Vuoi davvero tornare indietro?',
  },
  agentAppearance: {
    title: 'Aspetto',
    subtitle: "Personalizza l'aspetto del tuo assistente",
    icon: 'Icona',
    color: 'Colore',
    iconHelp: "Scegli un'icona adatta al tuo brand",
    colorHelp: "Scegli un colore per l'interfaccia dell'assistente",
  },
  agentBehavior: {
    title: 'Comportamento',
    subtitle: 'Controlla come risponde il tuo assistente',
    systemPrompt: 'Prompt di sistema',
    systemPromptHelp: 'Guida il tono e la personalità del tuo assistente',
    guardrails: 'Limitazioni',
    guardrailsHelp: 'Definisci cosa il tuo assistente non deve fare',
    temperature: 'Temperatura',
    maxTokens: 'Token massimi',
    topP: 'Top P',
    frequencyPenalty: 'Penalità di frequenza',
    presencePenalty: 'Penalità di presenza',
  },
  agentKnowledge: {
    title: 'Conoscenza',
    subtitle: 'Collega fonti di conoscenza al tuo assistente',
    uploadFiles: 'Carica file',
    addLinks: 'Aggiungi link',
    addText: 'Aggiungi testo',
    upload: 'Carica',
    uploading: 'Caricamento...',
    uploaded: 'Caricato',
    uploadError: 'Errore di caricamento',
    remove: 'Rimuovi',
    removed: 'Rimosso',
    removeError: 'Errore durante la rimozione',
    maxFiles: 'Fino a 10 file',
    maxSize: 'Fino a 10 MB per file',
    supportedFormats: 'PDF, DOCX, TXT',
  },
  agentPreview: {
    title: 'Anteprima',
    subtitle: 'Prova il tuo assistente prima di lanciarlo',
    welcomeMessage: 'Benvenuto! Sono il tuo nuovo assistente. Come posso aiutarti?',
    inputPlaceholder: 'Inserisci un messaggio...',
    send: 'Invia',
  },
  agentReview: {
    title: 'Rivedi e lancia',
    subtitle: 'Rivedi le impostazioni prima di lanciare il tuo assistente',
    launch: 'Lancia assistente',
    launching: 'Avvio...',
    launched: 'Lanciato',
    launchError: "Errore durante l'avvio dell'assistente",
  },
  agentValidation: {
    nameRequired: 'Il nome è obbligatorio',
    descriptionRequired: 'La descrizione è obbligatoria',
    languageRequired: 'La lingua è obbligatoria',
    timezoneRequired: 'Il fuso orario è obbligatorio',
  },
  assistantFilters: {
    title: 'Filtri',
    clearAll: 'Cancella tutto',
    apply: 'Applica',
    createdAt: 'Creato il',
    updatedAt: 'Aggiornato il',
    visibility: 'Visibilità',
    all: 'Tutti',
    public: 'Pubblico',
    private: 'Privato',
  },
  timezones: {
    search: 'Cerca fusi orari...',
    noResults: 'Nessun fuso orario trovato',
  },
  languages: {
    search: 'Cerca lingue...',
    noResults: 'Nessuna lingua trovata',
  },
  alerts: {
    successTitle: 'Successo',
    errorTitle: 'Errore',
    warningTitle: 'Avviso',
    infoTitle: 'Info',
  },
  validation: {
    required: 'Questo campo è obbligatorio',
    invalidEmail: 'Indirizzo e-mail non valido',
    minLength: 'Lunghezza minima {{count}} caratteri',
    maxLength: 'Lunghezza massima {{count}} caratteri',
  },
  date: {
    today: 'Oggi',
    yesterday: 'Ieri',
    daysAgo: '{{count}} giorni fa',
  },
  attachments: {
    dropFiles: 'Rilascia qui i file per caricarli',
    browse: 'Sfoglia',
    uploading: 'Caricamento...',
    upload: 'Carica',
    uploaded: 'Caricato',
    uploadError: 'Errore di caricamento',
    remove: 'Rimuovi',
    removed: 'Rimosso',
    removeError: 'Errore durante la rimozione',
  },
  prompts: {
    title: 'Prompt',
    subtitle: 'Gestisci i modelli e i preset di prompt',
    create: 'Crea prompt',
    edit: 'Modifica prompt',
    delete: 'Elimina prompt',
    name: 'Nome',
    description: 'Descrizione',
    content: 'Contenuto',
    created: 'Prompt creato',
    updated: 'Prompt aggiornato',
    deleted: 'Prompt eliminato',
    creationError: 'Errore durante la creazione del prompt',
    updateError: "Errore durante l'aggiornamento del prompt",
    deletionError: "Errore durante l'eliminazione del prompt",
    deleteConfirmTitle: 'Elimina prompt',
    deleteConfirmMessage: 'Sei sicuro di voler eliminare questo prompt?',
    deleteWarning: 'Questa azione non può essere annullata.',
  },
  promptEditor: {
    title: 'Editor di prompt',
    subtitle: 'Crea e modifica i tuoi prompt',
    save: 'Salva prompt',
    saved: 'Prompt salvato',
    saveError: 'Errore durante il salvataggio del prompt',
    variables: 'Variabili',
    addVariable: 'Aggiungi variabile',
    variableName: 'Nome variabile',
    variablePlaceholder: 'Inserisci il nome della variabile',
    variableExample: 'Esempio: nome, contesto, data',
    removeVariable: 'Rimuovi variabile',
  },
  promptPresets: {
    title: 'Preset di prompt',
    subtitle: 'Scegli tra impostazioni di prompt predefinite',
    systemPrompts: 'Prompt di sistema',
    userPrompts: 'Prompt utente',
    assistantPrompts: 'Prompt assistente',
    tone: 'Tono',
    tones: {
      professional: 'Professionale',
      casual: 'Informale',
      friendly: 'Amichevole',
      formal: 'Formale',
    },
    style: 'Stile',
    styles: {
      concise: 'Conciso',
      detailed: 'Dettagliato',
      persuasive: 'Persuasivo',
      informative: 'Informativo',
    },
  },
  knowledge: {
    title: 'Fonti di conoscenza',
    subtitle: 'Gestisci le fonti di dati per i tuoi assistenti',
    addSource: 'Aggiungi fonte',
    searchSources: 'Cerca fonti',
    sourceType: 'Tipo di fonte',
    sourceTypes: {
      document: 'Documento',
      url: 'URL',
      database: 'Database',
    },
    status: 'Stato',
    statuses: {
      processing: 'Elaborazione',
      ready: 'Pronto',
      failed: 'Non riuscito',
    },
    lastUpdated: 'Ultimo aggiornamento',
    actions: 'Azioni',
    view: 'Visualizza',
    edit: 'Modifica',
    delete: 'Elimina',
    deleteConfirm: 'Sei sicuro di voler eliminare questa fonte?',
    deleteWarning: 'Questa azione non può essere annullata.',
  },
  knowledgeForm: {
    title: 'Aggiungi fonte di conoscenza',
    sourceType: 'Tipo di fonte',
    name: 'Nome',
    description: 'Descrizione',
    url: 'URL',
    file: 'File',
    status: 'Stato',
    submit: 'Invia',
    submitting: 'Invio...',
    submitted: 'Inviato',
    submitError: "Errore durante l'invio della fonte",
  },
  knowledgeStatus: {
    processing: 'Elaborazione',
    ready: 'Pronto',
    failed: 'Non riuscito',
  },
  behavior: {
    title: 'Comportamento',
    systemPrompt: 'Prompt di sistema',
    instructions: 'Istruzioni',
    temperature: 'Temperatura',
    maxTokens: 'Token massimi',
    topP: 'Top P',
    frequencyPenalty: 'Penalità di frequenza',
    presencePenalty: 'Penalità di presenza',
    save: 'Salva',
    saved: 'Salvato',
    saveError: 'Errore durante il salvataggio',
  },
  placeholders: {
    search: 'Cerca...',
    enterText: 'Inserisci testo...',
    enterName: 'Inserisci nome...',
    enterDescription: 'Inserisci descrizione...',
  },
  roles: {
    owner: 'Proprietario',
    admin: 'Admin',
    editor: 'Editor',
    viewer: 'Visualizzatore',
  },
  pagination: {
    previous: 'Precedente',
    next: 'Successivo',
    page: 'Pagina',
    of: 'di',
  },
  emptyStates: {
    noData: 'Nessun dato disponibile',
    noResults: 'Nessun risultato',
    noAccess: 'Nessun accesso',
  },
  filters: {
    apply: 'Applica',
    reset: 'Reimposta',
    clear: 'Cancella',
    sort: 'Ordina',
    filter: 'Filtra',
  },
  breadcrumbs: {
    home: 'Home',
    back: 'Indietro',
  },
  tags: {
    addTag: 'Aggiungi tag',
    add: 'Aggiungi',
    remove: 'Rimuovi',
    required: 'È richiesto almeno un tag',
    tagsHelp: 'I tag aiutano a organizzare e categorizzare il tuo assistente',
    exampleQuestions: 'Domande di esempio',
    exampleQuestionsHelp:
      'Aggiungi domande di esempio su cui gli utenti possono fare clic per avviare una conversazione',
  },
  editAgent: {
    title: 'Modifica assistente',
    subtitle: 'Modifica le impostazioni e il comportamento del tuo assistente IA',
    updateAgent: 'Aggiorna assistente',
    deleteAgent: 'Elimina assistente',
    updating: 'Aggiornamento...',
    deleting: 'Eliminazione...',
    agentUpdated: 'Assistente aggiornato',
    updatedSuccessfully: 'è stato aggiornato con successo',
    updateError: 'Errore di aggiornamento',
    updateErrorDescription: "Si è verificato un errore durante l'aggiornamento dell'assistente. Riprova.",
    agentDeleted: 'Assistente eliminato',
    deletedSuccessfully: 'è stato eliminato con successo',
    deleteError: 'Errore di eliminazione',
    deleteErrorDescription: "Si è verificato un errore durante l'eliminazione dell'assistente. Riprova.",
    deleteConfirmTitle: 'Elimina assistente',
    deleteConfirmMessage: 'Sei sicuro di voler eliminare questo assistente? Questa azione non può essere annullata.',
    confirmDelete: 'Sì, elimina',
    loadingAgent: "Caricamento dei dettagli dell'assistente...",
    failedToLoad: "Impossibile caricare i dettagli dell'assistente",
  },
  jobCategory: {
    addNew: 'Aggiungi categoria',
    name: 'Nome',
    nameRequired: 'Il nome della categoria è obbligatorio',
    enterName: 'Inserisci il nome della categoria...',
    create: 'Crea',
    edit: 'Modifica',
    update: 'Aggiorna',
    delete: 'Elimina',
    created: 'Categoria creata',
    createdSuccessfully: 'è stata creata con successo',
    updated: 'Categoria aggiornata',
    updatedSuccessfully: 'è stata aggiornata con successo',
    deleted: 'Categoria eliminata',
    deletedSuccessfully: 'è stata eliminata con successo',
    creationError: 'Errore di creazione',
    creationErrorDescription: 'Si è verificato un errore durante la creazione della categoria',
    updateError: 'Errore di aggiornamento',
    updateErrorDescription: "Si è verificato un errore durante l'aggiornamento della categoria",
    deletionError: 'Errore di eliminazione',
    deletionErrorDescription: "Si è verificato un errore durante l'eliminazione della categoria",
    deleteError: 'Errore di eliminazione',
    deleteErrorDescription: "Si è verificato un errore durante l'eliminazione della categoria",
    deleteConfirmTitle: 'Elimina categoria',
    deleteConfirmMessage: 'Sei sicuro di voler eliminare "{{name}}"?',
    deleteWarning: 'Questa azione non può essere annullata e può influenzare gli assistenti esistenti.',
    warning: 'Avviso',
    agentsWillLoseCategory: "gli assistenti perderanno l'assegnazione della categoria",
  },
  languageNames: {
    en: 'Inglese',
    nl: 'Olandese',
    de: 'Tedesco',
    fr: 'Francese',
    it: 'Italiano',
    pl: 'Polacco',
    hu: 'Ungherese',
    id: 'Indonesiano',
  },
  knowledgeSourceSelector: {
    title: 'Fonti di conoscenza',
    tooltip: 'Scegli quali fonti di conoscenza cercare',
    all: 'Tutte',
  },
  countries: {
    nl: 'Paesi Bassi',
    us: 'Americhe',
    hu: 'Ungheria',
    id: 'Indonesia',
  },
  iconSelector: {
    chooseIcon: "Scegli un'icona",
  },
  models: {
    optionUnavailable: '{{model}} — temporaneamente non disponibile',
    modelRateLimited: '{{model}} è temporaneamente limitato. Le richieste vengono indirizzate al modello disponibile successivo.',
    modelUnavailable: '{{model}} non è al momento disponibile. Le richieste vengono indirizzate a un altro modello.',
    fallbackToast: 'Passato a {{fallbackModel}} — {{originalModel}} temporaneamente non disponibile.',
    recommended: 'Consigliato',
    verifySources: 'Questa risposta arriva da un modello meno affidabile sulle domande HR. Verificala alla fonte prima di agire.',
    introHeading: 'Impostazioni dei modelli',
    introBody: 'In questa pagina imposti come si comporta ogni modello. Quale modello viene usato per una conversazione non si sceglie qui, lo selezioni nella chat stessa, accanto al campo in cui scrivi la tua domanda.',
    noConfigurableParameters: 'Nessuna impostazione per questo modello',
  },
}

const clientDefaults = {
  fallbackAgentDescription: 'Assistente IA per le conoscenze aziendali da AHV International.',
}

export default { ...itTranslation, ...clientDefaults }
